import React from 'react'
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner-center">
        <div class="spinner"></div>
    </div>
  )
}

export default Spinner